import { axios, Response } from '../index'
import { Post } from './get-post-by-id'

const unfixPost = (personaId: string, postId: number): Response<Post[]> => {
  return axios.put(`/v1/personas/${personaId}/posts/${postId}/unpin-post`)
}

export default unfixPost
